export default "__VITE_ASSET__CB64Mqxk__"